import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core'

@Directive({
    selector: '[appIndeterminateButtonLoading]',
})
export class IndeterminateButtonLoadingDirective implements OnInit {
    private _showAnimation: boolean | null = false

    loadingContainerDiv?: Element
    loadingDiv?: Element
    animationDivAppended = false
    darkMode = false

    @Input() set appIndeterminateButtonLoading(isLoading: boolean | null) {
        this._showAnimation = isLoading

        if (this._showAnimation) {
            this.showAnimation()
        } else {
            this.hideAnimation()
        }
    }

    @Input() set appIndeterminateButtonLoadingDarkMode(darkMode: boolean) {
        this.darkMode = darkMode

        if (this.loadingDiv) {
            if (darkMode) {
                this.renderer.addClass(this.loadingDiv, 'dark-mode')
            } else {
                this.renderer.removeClass(this.loadingDiv, 'dark-mode')
            }
        }
    }

    constructor(
        private renderer: Renderer2,
        private el: ElementRef
    ) {}

    ngOnInit() {
        if (this._showAnimation) {
            this.showAnimation()
        } else {
            this.hideAnimation()
        }
    }

    hideAnimation() {
        if (this.loadingContainerDiv && this.loadingDiv) {
            this.renderer.removeChild(this.loadingContainerDiv, this.loadingDiv)
            this.renderer.removeChild(this.el.nativeElement, this.loadingContainerDiv)
        }
        this.animationDivAppended = false
    }

    showAnimation() {
        if (this.animationDivAppended) {
            // already showing animation
            return
        }

        this.loadingContainerDiv = this.renderer.createElement('div')
        this.loadingDiv = this.renderer.createElement('div')

        this.renderer.addClass(this.loadingContainerDiv, 'loading-container')
        this.renderer.addClass(this.loadingDiv, 'loading-animation')

        if (this.darkMode) {
            this.renderer.addClass(this.loadingDiv, 'dark-mode')
        }

        this.renderer.appendChild(this.loadingContainerDiv, this.loadingDiv)
        this.renderer.appendChild(this.el.nativeElement, this.loadingContainerDiv)
        this.animationDivAppended = true
    }
}
